import React, { useState } from 'react';
import classNames from 'classnames';

import ToolbarPopup from '../../../toolbarPopup/ToolbarPopup';
import LabelsToolContent from '../LabelsToolContent';
import LabelEditPopup from './LabelEditPopup';
import useLabelPopupsState from '../hooks/useLabelPopupsState';
import { TooltipAlignment } from '../../../../../../components/tooltips/tooltipConstants';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import './LabelsToolbarPopup.scss';
import { LabelsToolbarPopupProps } from '../labelComponentPropTypes';
import { getRootBoardId } from '../../../../../../../common/users/utils/userPropertyUtils';

const LabelsToolbarPopup: React.FC<LabelsToolbarPopupProps> = (props) => {
    const { buttonSelector, currentUser, currentUserId } = props;

    const [showEditingPopup, setShowEditingPopup] = useState<boolean>(false);

    const toggleEditingPopup = (isOpen: boolean) => {
        setShowEditingPopup(isOpen);
    };

    const labelProps = useLabelPopupsState(toggleEditingPopup);

    const { currentlyEditingLabel, shareRootPath, showColorChange, handleClickColorChange, userRootPath } = labelProps;

    const userRootBoardId = getRootBoardId(currentUser);

    return (
        <ToolbarPopup
            buttonSelector={buttonSelector}
            alignment={TooltipAlignment.START}
            popupId={PopupIds.LABELS_TOOL}
            className={classNames('LabelsPopup')}
            showArrow={false}
        >
            <LabelsToolContent {...props} {...labelProps} />
            <LabelEditPopup
                label={currentlyEditingLabel}
                showEditingPopup={showEditingPopup}
                setShowEditingPopup={setShowEditingPopup}
                showColorMenu={showColorChange}
                onColorChangeClick={handleClickColorChange}
                shareRootPath={shareRootPath}
                userRootPath={userRootPath}
                userRootBoardId={userRootBoardId}
                currentUserId={currentUserId}
            />
        </ToolbarPopup>
    );
};

export default LabelsToolbarPopup;
